import React from 'react';
// import { Table } from '@radix-ui/themes';
// import '@radix-ui/themes/styles.css';


function SimpleTable({ data, columns }) {
    if (!data || !Array.isArray(data) || data?.length === 0) {
        return <p>No data available</p>;
    }

    return (
        <div className="overflow-auto max-h-[800px]">
            <table className="min-w-full bg-white border border-gray-300 divide-y divide-gray-300">
                <thead className="bg-white">
                    <tr>
                        {columns.map((col, index) => (
                            <th className="text-sm px-6 py-3 text-left text-green-600 uppercase tracking-wider" key={crypto.randomUUID()}>{col.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="text-gray-700">
                    {data.map((item, rowIndex) => (
                        <tr key={crypto.randomUUID()} className={rowIndex % 2 === 0 ? 'bg-gray-50' : ''}>
                            {columns.map((col, colIndex) => (
                                <td className="px-6 py-4 whitespace-normal max-w-xs break-words" key={colIndex}>{item[col.field]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default SimpleTable;
